export enum ReportStatus {
    draft = 'draft',
    released = 'released',
    inProgress = 'inProgress'
}
